import React from 'react';
import { createTheme } from '@abyss/web/tools/theme';
import { createRouter } from '@abyss/web/tools/createRouter';
import { AbyssProvider } from '@abyss/web/ui/AbyssProvider';
import { ThemeProvider } from '@abyss/web/ui/ThemeProvider';
import { RouterProvider } from '@abyss/web/ui/RouterProvider';
import { Routes } from './routes';

const theme = createTheme('optum');
const router = createRouter(Routes);

export const browser = () => {
  return (
    <AbyssProvider theme={theme} router={router}>
      <ThemeProvider>
        <RouterProvider router={router} children={undefined} />
      </ThemeProvider>
    </AbyssProvider>
  );
};
